window.customOptionsOperations = {
    websiteId:7,
    convertFromToArray: function (form) {
        const formDataArray = Array.from(form.entries());
        let data = {}, selectedOptions = {};
        formDataArray.forEach(item => {
            if (item[0].indexOf("options[") > -1) {
                data[item[0]] = item[1];
            }
        });
        return data;
    },
    prepareOptionsToImage: function (data) {
        let threedModel = window.productCustomOptions.threedModel;
        let components = [];
        let modelId = threedModel;
        if (typeof threedModel == "object") {
            modelId = threedModel.Model;
            components =[...threedModel.Components];
        }
        for (const optionId in window.productCustomOptions.options) {
            if (data["options[" + optionId + "]"] == undefined) continue;
            let item = window.productCustomOptions.options[optionId];
            let value = data["options[" + optionId + "]"];
            let subOption = item.field_type != "field" ? item[value] : null;
            if (subOption != null) {
                if (item["threed_group"] != "" && item["threed_group"].indexOf("NO_SERVICE") == -1 && subOption.sku != "") {
                    let modelGroupsSplit = item["threed_group"].split(",");
                      let newSku = subOption.sku;
                        if (subOption.hasOwnProperty('sku3d_override') && subOption['sku3d_override']) {
                            newSku = subOption['sku3d_override'];
                        }
                    if (modelGroupsSplit.length > 0) {
                        if (modelGroupsSplit.length > 1) {
                            modelGroupsSplit.forEach(group => {
                                components.push({ "Group": group, "Filename": newSku })
                            })
                        } else {
                            components.push({ "Group": item["threed_group"], "Filename": newSku })
                        }
                    }
                }
            }
        }
        
        return { Model_Number: modelId, Components: components, Device: 0, Website_Id: this.websiteId };
    },
    getImages: async function (data, url, code) {
        const sendData = new FormData();
        let sendUrl = window.backendUrl + url +"?code=" + code;
        sendData.append("raw", JSON.stringify(data));
        let res = await fetch(sendUrl, {
                      method: "POST",
                       body: sendData,
                  });
         let json = await res.json();
         
         return json;
    },
    generateCrmData: function (data) {
        let ProductOptions = window.productCustomOptions;
        let _this = this;
        let crmItemId = ProductOptions["crm_item_id"];

        let ShopifyItems = [];


        let crmQty = 1;
        let productId = 3302;
        let tempUniq = this.uniqid();
        let productName = "{{ product.title | escape }}";
        let selectedOptions = {};

        for (const optionId in ProductOptions.options) {
            if (data["options[" + optionId + "]"] == undefined) continue;
            let value = data["options[" + optionId + "]"];
            selectedOptions[optionId] = value;
        }
        let crmItemSubOptionIdArr = ProductOptions['crm_suboption_id'] ? ProductOptions['crm_suboption_id'].split(",") : [];
        if (crmItemSubOptionIdArr.length && crmItemId != "") {
            crmItemSubOptionIdArr.forEach(suboption => {
                crmSubOptionArray.push(_this.createSubOption(suboption, ''));
            });
            ShopifyItems.push(_this.createShopifyItem(crmItemId, crmQty, crmSubOptionArray, productId, productName, false, tempUniq));


        } else {
            let crmItemOptionIdArray = [];
                  crmItemOptionIdArray = this.getCrmItemMainOtion(selectedOptions);
           // for (const optionId in selectedOptions) {
          
                //if (ProductOptions.options[optionId]['crm_item_id'] != "") {
                //    crmItemOptionIdArray.push(ProductOptions.options[optionId]['crm_item_id']);
                //}

           // }
            if (crmItemOptionIdArray.length) {
                crmItemOptionIdArray.forEach(item => {
                    ShopifyItems.push(_this.prepareJSON(selectedOptions, item, crmQty, productId, tempUniq));
                });
            }
            ShopifyItems.push(_this.prepareJSON(selectedOptions, false, crmQty, productId, tempUniq));
        }
        return ShopifyItems;
    },
    uniqid: function (prefix = '', moreEntropy = false) {
        const ts = Date.now().toString(16);
        const random = Math.floor(Math.random() * 0x75bcd15).toString(16);
        let id = prefix + ts + random;

        if (moreEntropy) {
            id += (Math.random() * 10).toFixed(8).toString();
        }

        return id;
    },
    getCrmItemMainOtion: function (data) {
        let crmItemOptionIdArray = [];
        let ProductOptions = window.productCustomOptions;
        for (const optionId in data) {
         //   if (data[optionId] == undefined) continue;
            if (ProductOptions.options[optionId]['field_type'] != 'field' && ProductOptions.options[optionId][data[optionId]].hasOwnProperty('crm_sub_option_item_id') && ProductOptions.options[optionId][data[optionId]]['crm_sub_option_item_id'] != "") {
                crmItemOptionIdArray.push(ProductOptions.options[optionId][data[optionId]]['crm_sub_option_item_id']);
            } else if (ProductOptions.options[optionId]['crm_item_id'] != "") {
                crmItemOptionIdArray.push(ProductOptions.options[optionId]['crm_item_id']);
            }
        }
        return crmItemOptionIdArray;
    },
    createShopifyItem: function (CRM_Item_ID, Quantity, Sub_Options, Magento_Item_ID, Magento_Item_Summary, Accessory, Temp_ID) {
        return {
            "CRM_Item_ID": CRM_Item_ID,
            "Quantity": Quantity,
            "Sub_Options": Sub_Options,
            "Magento_Item_ID": Magento_Item_ID,
            "Magento_Item_Summary": Magento_Item_Summary,
            "Accessory": Accessory,
            "Temp_ID": Temp_ID
        }
    },
    createSubOption: function (subOptionId, subOptionValue) {

        return { "Sub_Option_ID": subOptionId, "Sub_Option_Value": subOptionValue };
    },
    prepareJSON: function (selectedOptions, crmItemMainOptionId, crmQty, productId, unique) {
        let ProductOptions = window.productCustomOptions;
        let crmItemQtyTemp = 0;
        let crmSubOptionArray = [];
        let customOptionString = "";
        let crmOptions = [];
        let crmItemId = ProductOptions["crm_item_id"];
        let ShopifyObject = false;
        if (crmItemId != "") {
            for (const optionId in selectedOptions) {
                let optionTitle = "";
                let value = selectedOptions[optionId];
                if (ProductOptions.options[optionId]['crm_item_id']) {
                    crmOptions.push(ProductOptions.options[optionId]['crm_item_id']);
                }
                optionTitle = ProductOptions.options[optionId]['title'];
                if (ProductOptions.options[optionId][value] != undefined) {
                    optionTitle += ":" + ProductOptions.options[optionId][value]["title"] + ",";
                }
                customOptionString += optionTitle;
                if ((crmItemMainOptionId == false || ((ProductOptions.options[optionId]['crm_item_id'] == crmItemMainOptionId) && crmItemMainOptionId != false))  && ProductOptions.options[optionId]['field_type'] == "field") {
                    crmSubOptionArray.push(this.createSubOption(ProductOptions.options[optionId]['crm_sub_option_id'], value));
                } else {
                    if (ProductOptions.options[optionId][value] != undefined && ProductOptions.options[optionId][value]['crm_sub_option_id'] != "") {
                        if (((ProductOptions.options[optionId]['crm_item_id'] == crmItemMainOptionId ||  ProductOptions.options[optionId][value]['crm_sub_option_item_id'] == crmItemMainOptionId) && crmItemMainOptionId != false) || (crmItemMainOptionId == false && (ProductOptions.options[optionId]['crm_item_id'] == "" && (ProductOptions.options[optionId][value]['crm_sub_option_item_id'] == undefined ||ProductOptions.options[optionId][value]['crm_sub_option_item_id'] == "" )))) {
                            $crmOptionArr = ProductOptions.options[optionId][value]['crm_sub_option_id'] ? ProductOptions.options[optionId][value]['crm_sub_option_id'].split(",") : [];
                            // Check if field crm item qty in sub topion is > 0 and null.
                            if (ProductOptions.options[optionId][value].hasOwnProperty('crm_sub_option_item_qty') && ProductOptions.options[optionId][value]['crm_sub_option_item_qty']) { crmItemQtyTemp = crmItemQtyTemp + ProductOptions.options[optionId][value]['crm_sub_option_item_qty'];
                            } else if (ProductOptions.options[optionId]['crm_item_qty'])  {
                                crmItemQtyTemp = crmItemQtyTemp + ProductOptions.options[optionId]['crm_item_qty'];
                            }
                            $crmOptionArr.forEach(crmSub => {
                                // Support "ID-Value" tokens (e.g. "908-48"); a plain number
                                // (including the "-1" None sentinel) is used as-is so a leading
                                // minus is not mistaken for the ID-Value separator.
                                crmSub = String(crmSub).trim();
                                let crmSubValue;
                                let crmSubOptionValue;
                                if (crmSub !== '' && !isNaN(crmSub)) {
                                    crmSubValue = parseInt(crmSub, 10);
                                    crmSubOptionValue = '';
                                } else {
                                    let separatorPos = crmSub.indexOf('-');
                                    if (separatorPos === -1) {
                                        crmSubValue = parseInt(crmSub, 10) || 0;
                                        crmSubOptionValue = '';
                                    } else {
                                        crmSubValue = parseInt(crmSub.slice(0, separatorPos), 10) || 0;
                                        crmSubOptionValue = crmSub.slice(separatorPos + 1).trim();
                                    }
                                }
                                if (crmSubValue !== 0) {
                                    crmSubOptionArray.push(this.createSubOption(crmSubValue, crmSubOptionValue));
                                }
                            });

                        }
                    }
                }
            }
            let accessory = false;
            if (crmItemMainOptionId != false) {
                if (crmItemMainOptionId.toString().indexOf("NO_ACCESSORY") == -1) {
                    crmItemId = crmItemMainOptionId;
                    accessory = true;
                } else {
                    crmItemId = crmItemMainOptionId.replace(" NO_ACCESSORY", "");
                    accessory = false;
                }

                if (crmItemQtyTemp > 0) {
                    crmQty = crmQty * crmItemQtyTemp;
                }
            }
            if (crmSubOptionArray.length) {
                ShopifyObject = this.createShopifyItem(crmItemId, crmQty, crmSubOptionArray, productId, customOptionString, accessory, unique);
            } else {
                ShopifyObject = this.createShopifyItem(crmItemId, crmQty, [], productId, customOptionString, accessory, unique);
            }
        }

        return ShopifyObject;
    },
    prepareOptions: function (data) {
        let selectedCustomOptions = [];
        let selectedOptions = {};
        for (const optionId in ProductOptions.options) {
            if (data["options[" + optionId + "]"] == undefined) continue;
            let value = data["options[" + optionId + "]"];
            selectedOptions[optionId] = value;
        }
        for (const optionId in selectedOptions) {
            let typeValue = "";
            if (ProductOptions.options[optionId]["field_type"] != "field") {
                typeValue = ProductOptions.options[optionId][selectedOptions[optionId]]['title'];
            } else {
                typeValue = selectedOptions[optionId];
            }
            selectedCustomOptions.push({ "name": "options[" + optionId + "]", "value": ProductOptions.options[optionId]['title'] + ":" + typeValue });
        }

        return selectedCustomOptions;
    },

    prepareOptionstoJSON: function (data) {
        let selectedCustomOptions = [];
        let selectedOptions = {};
        let lengthRegex = /^Length\s\w$/;
        for (const optionId in ProductOptions.options) {
            if (data["options[" + optionId + "]"] == undefined) continue;
            let value = data["options[" + optionId + "]"];
            selectedOptions[optionId] = value;
        }
        for (const optionId in selectedOptions) {
            let typeValue = "";
            if (ProductOptions.options[optionId]["field_type"] != "field") {
                typeValue = ProductOptions.options[optionId][selectedOptions[optionId]]['title'];
            } else {
                typeValue = selectedOptions[optionId];
            }
            let title = ProductOptions.options[optionId]['title'];
            if (lengthRegex.test(title)) {
                typeValue +="\"";
            }
            selectedCustomOptions.push(ProductOptions.options[optionId]['title'] +':' +typeValue);
        }

        return selectedCustomOptions.join("||");
    },
     prepareOptionstoAdditional: function (data) {
        let selectedCustomOptions = [];
        let selectedOptions = {};
        let lengthRegex = /^Length\s\w$/;
        for (const optionId in ProductOptions.options) {
            if (data["options[" + optionId + "]"] == undefined) continue;
            let value = data["options[" + optionId + "]"];
            selectedOptions[optionId] = value;
        }
        for (const optionId in selectedOptions) {
            let typeValue = "";
            if (ProductOptions.options[optionId]["field_type"] != "field") {
                typeValue = ProductOptions.options[optionId][selectedOptions[optionId]]['title'];
            } else {
                typeValue = selectedOptions[optionId];
            }
            let title = ProductOptions.options[optionId]['title'];
            if (lengthRegex.test(title)) {
                typeValue +="\"";
            }
            selectedCustomOptions.push(ProductOptions.options[optionId]['title'] +': ' +typeValue);
        }

        return selectedCustomOptions.join(", ");
    },
    getPrice: async function(data, url, code) {
        const sendData = new FormData();
        let sendUrl = window.backendUrl + url +"?code=" + code;
        sendData.append("raw", JSON.stringify(data));
        let response = await fetch(sendUrl, {
                      method: "POST",
                      body: sendData,
                  });
            if (response.ok) {
                return response.json();
        } else {
            return {"error" : true};
        }
    },
    changeImageSize(url, target) {
                let urlArray = url.split(',');
                let {targetWidth, targetHeight, maxWidth, priority} = target;
                let resultUrl = '';
                let widthSelected = false, heightSelected = false;
                let width, height, currentWidth, currentHeight;
                urlArray.forEach(item => {
                    if (!widthSelected && item.indexOf('w_') > -1) {
                        if (item.match(/w_\d\.\d\//) == null) {;
                            currentWidth = parseInt(item.substring(item.indexOf('w_') + 2));
                            widthSelected = true;
                        }
                    }
                    if (!heightSelected && item.indexOf('h_') > -1) {
                        if (item.match(/h_\d\.\d/) == null) {
                            currentHeight = parseInt(item.substring( item.indexOf('h_') + 2));
                            heightSelected = true;
                        }
                    }
                });
                let ratio = false;
                if (url.indexOf('c_crop') === -1 && !!currentWidth && !!currentHeight) {
                    ratio = currentWidth / currentHeight;
                }
                if (!!ratio) {
                    if (priority === 'width') {
                        width = targetWidth;
                        height = Math.floor(width / ratio);
                    }
                    if (priority === 'height') {
                        height = targetHeight;
                        width = Math.floor(height * ratio);
                    }
                } else {
                    if (!!targetWidth) width = targetWidth;
                    if (!!targetHeight) height = targetHeight;
                }
                if (!!currentWidth && width > currentWidth) width = currentWidth;
                if (!!maxWidth && width > maxWidth) width = maxWidth;
                urlArray.forEach(item => {
                    if (item.indexOf('/v1/') > -1) {
                        resultUrl += item.replace('/v1/', '/w_' + width + '/v1/') + ',';
                    } else {
                        resultUrl += item + ',';
                    }
                });
                resultUrl = resultUrl.substring(0, resultUrl.length - 1);
                return resultUrl;
            },

            generateSlider(slider, sectionId, thumbnails, next, prev, gallery, images, zoom, divBlock, usingConfig) {
                  if (slider.prevButton == null) {
                    let prevButton = document.createElement("button");
                    prevButton.innerHTML = prev;
                    prevButton.setAttribute("type", "button");
                    prevButton.setAttribute(
                      "class",
                      "absolute left-2 z-10 rounded-full p-3 shadow-md bg-white bg-opacity-80 hover:bg-opacity-75 disabled:bg-gray-600 disabled:bg-opacity-50 disabled:opacity-50",
                    );
                    prevButton.setAttribute("name", "previous");
                    prevButton.setAttribute("aria-label", "Slide left");
                    prevButton.setAttribute(
                      "aria-controls",
                      "GalleryStatic-" + sectionId,
                    );
                    prevButton.setAttribute("data-step", "3");
                    slider.insertBefore(prevButton, slider.querySelector("ul"));
                    slider.prevButton = slider.querySelector(
                      'button[name="previous"]',
                    );
                  }
                  if (slider.nextButton == null) {
                    let nextButton = document.createElement("button");
                    nextButton.innerHTML = next;
                    nextButton.setAttribute("type", "button");
                    nextButton.setAttribute(
                      "class",
                      "absolute right-4 z-10 rounded-full p-3 shadow-md bg-white bg-opacity-80 hover:bg-opacity-75 disabled:bg-gray-600 disabled:bg-opacity-50 disabled:opacity-50",
                    );
                    nextButton.setAttribute("name", "next");
                    nextButton.setAttribute("aria-label", "Slide right");
                    nextButton.setAttribute(
                      "aria-controls",
                      "GalleryStatic-" + sectionId,
                    );
                    nextButton.setAttribute("data-step", "3");
                    slider.appendChild(nextButton);
                    slider.nextButton = slider.querySelector(
                      'button[name="next"]',
                    );
                  }
                  let generateTemplate = "";
                  position = 1;
                  thumbnails.forEach((item) => {
                    generateTemplate += `
            <li id="Slide-StaticThumbnails-${sectionId}-${position}" class="flex relative flex-shrink-0 snap-start w-1/3 md:w-1/6 lg:w-1/6 p-1" data-target="s-${sectionId}-${position}" data-media-position="${position}">
              <button class="relative w-full h-full overflow-hidden" aria-label="Load image ${position} in gallery view" aria-controls="StaticViewer-${sectionId}" aria-describedby="thumbnailstatic-${sectionId}-${position}">
                <div class="border border-gray-400 p-1 w-full">
                <img class="w-full h-full aspect-square object-contain object-center motion-reduce select-none" src="${item}" srcset="" sizes="(max-width: 360px) 320px, (max-width: 400px) 400px, (max-width: 768px) 768px, (max-width: 1280px) 1280px, 100vw" width="107" height="107" alt="" id="thumbnailstatic-${sectionId}-${position}" loading="lazy">
                </div>
              </button>
            </li>`;
                    position++;
                  });
                  slider.querySelector("ul").innerHTML = generateTemplate;
                   /*  let imagesGal = [...slider.querySelectorAll("img")];
                  const loadPromises = imagesGal.map(img => 
                        new Promise((resolve) => {
                        if (img.complete) {
                            resolve();  // Already loaded
                        } else {
                            img.onload = img.onerror = resolve;  // Resolve on load or error [web:1][web:3]
                            }
                         })
                    );
                    Promise.all(loadPromises).then(() => {
                            slider.reload();
                        })*/
                  slider.reload();
               //   slider.update();
                  let ulElement = gallery.querySelector("ul");
                  ulElement.innerHTML = "";
                  position = 1;
                  let templates = images.map((item) => {
                    let imageCloud = item.url;
                    let imOrig = this.changeImageSize(
                      item.url,
                      {
                        targetWidth: 1024,
                        targetHeight: 0,
                        priority: "width",
                      },
                    );
                    let im107 = this.changeImageSize(
                      item.url,
                      {
                        targetWidth: 107,
                        targetHeight: 0,
                        priority: "width",
                      },
                    );
                    let im320 = this.changeImageSize(
                      item.url,
                      {
                        targetWidth: 320,
                        targetHeight: 0,
                        priority: "width",
                      },
                    );
                    let im400 = this.changeImageSize(
                      item.url,
                      {
                        targetWidth: 400,
                        targetHeight: 0,
                        priority: "width",
                      },
                    );
                    let im550 = this.changeImageSize(
                      item.url,
                      {
                        targetWidth: 550,
                        targetHeight: 0,
                        priority: "width",
                      },
                    );
                    let im650 = this.changeImageSize(
                      item.url,
                      {
                        targetWidth: 650,
                        targetHeight: 0,
                        priority: "width",
                      },
                    );
                    let liElement = document.createElement("li");
                    let noscript = document.createElement("noscript");
                    noscript.innerHTML = `<div class="relative h-full w-full overflow-auto">
                    <img class="w-full h-full aspect-square object-contain object-center motion-reduce select-none"
                        src="${imageCloud}"
                        srcset="${imageCloud} 107w,${imageCloud} 320w,${imageCloud} 400w,${imageCloud} 550w,${imageCloud} 650w"
                        sizes="(max-width: 360px) 320px, (max-width: 400px) 400px, 100vw"
                        width="1024" height="1024"
                        alt="" loading="lazy">
                    </div>`;
                    liElement.appendChild(noscript);
                    liElement.setAttribute(
                      "id",
                      "Slide-Thumbnails-" + sectionId + "-" + position,
                    );
                    liElement.setAttribute(
                      "class",
                      "h-full border bg-white border-gray-400 items-center justify-center snap-start flex-shrink-0 w-full hidden open:flex p-5",
                    );
                    liElement.setAttribute(
                      "data-media-id",
                      "s-"+sectionId + "-" + position,
                    );
                    if (position == 1) {
                      liElement.setAttribute("open", true);
                    }
                    //   liElement.setAttribute("role","presentation");
                    let modalElement = document.createElement("modal-opener");
                    modalElement.setAttribute(
                      "class",
                      "relative h-full w-full overflow-auto",
                    );
                    modalElement.setAttribute(
                      "data-modal",
                      "#ProductStaticModal-" + sectionId,
                    );
                    modalElement.innerHTML = `
                        <img class="w-full h-full aspect-square object-contain object-center motion-reduce select-none" src="${imageCloud}" srcset="
                    ${imageCloud} 107w,${imageCloud} 320w,${imageCloud} 400w,${imageCloud} 550w,${imageCloud} 650w" sizes="(max-width: 360px) 320px, (max-width: 400px) 400px, 100vw" width="720" height="720" alt="" loading="lazy">
                        <button class="absolute inset-0 flex items-start" aria-label="Open media ${position} in modal" type="button" aria-haspopup="dialog" data-media-id="s-${position}">
                                    <span class="sr-only">Open media ${position} in modal</span>
                                    <span class="p-2 m-2">
                            ${zoom}
                        </span>
                    </button>
                    </modal-opener>`;
                    if (usingConfig && item.sku != null) {
                        modalElement.innerHTML +=`<div class="load-configuration-link absolute bg-white p-4 text-black left-4 bottom-4 cursor-pointer" data-sku="${item.sku}">Select Style</div>`;
                    }
                    modalElement.updateLink();
                    position++;
                    liElement.appendChild(modalElement);
                    ulElement.appendChild(liElement);
                    //return item.url;
                  });

                  gallery.reload();
                   divBlock.innerHTML = '';
                    position = 1;
                    images.map((item) => {
                    let imageCloud = item.url;
                    let imOrig = window.customOptionsOperations.changeImageSize(item.url, {
                        targetWidth: 1445,
                        targetHeight: 0,
                        priority: 'width',
                    });
                    let im550 = window.customOptionsOperations.changeImageSize(item.url, {
                        targetWidth: 550,
                        targetHeight: 0,
                        priority: 'width',
                    });
                    let im1100 = window.customOptionsOperations.changeImageSize(item.url, {
                        targetWidth: 1100,
                        targetHeight: 0,
                        priority: 'width',
                    });
                    let im1376 = window.customOptionsOperations.changeImageSize(item.url, {
                        targetWidth: 1376,
                        targetHeight: 0,
                        priority: 'width',
                    });
                    let newDiv = document.createElement('div');
                    newDiv.setAttribute(
                        'class',
                        'relative mx-auto h-full max-w-4xl bg-white shadow-2xl p-4 md:p-10 mb-10 object-contain'
                    );
                    let newSpan = document.createElement('span');
                    newSpan.setAttribute('class', 'absolute -top-4');
                    newSpan.setAttribute('data-media-id', "s-" +position);
                    newSpan.setAttribute('aria-hidden', true);
                    newDiv.appendChild(newSpan);
                    let imgNew = document.createElement('img');
                    imgNew.setAttribute('class', 'w-full h-full object-contain object-center motion-reduce max-h-screen');
                    imgNew.setAttribute('width', '1100');
                    imgNew.setAttribute('height', '1100');
                    imgNew.setAttribute('alt', '{{product.title}}');
                    imgNew.setAttribute('src', imageCloud);
                    imgNew.setAttribute('srcset', imageCloud + ' 550w,' + imageCloud + ' 1100w,' + imageCloud + ' 1376w');
                    imgNew.setAttribute('sizes', '(min-width: 750px) calc(100vw - 22rem), 1100px');
                    newDiv.appendChild(imgNew);
                    divBlock.appendChild(newDiv);
                    position++;
                    }   );
                    const buttons = document.querySelectorAll('.load-configuration-link');
                    buttons.forEach(button => {
 
                        button.addEventListener('click', (event) => {
                            const sku = event.target.getAttribute('data-sku');
                             window.dispatchEvent(new CustomEvent('load-configuration', {detail: {sku: sku}}));
                        });
                    });
              //    divBlock.setAttribute("role","static-document");
            }
}
function wEvent(name, data) {
    window.dispatchEvent(new CustomEvent(name, {detail: data}));
}
function getImgRequestId() {
    let form = document.querySelector('#product_addtocart_form_new_' + window.configuratorUniqueId);
    let formData = new FormData(form);
    let imgRequestId = '';
    formData.forEach((val, key) => {
        if (key !== 'qty'
            && key !=='form_key'
            && key !== 'product'
            && key !== 'sku')
            imgRequestId += key + val;
    });
    return imgRequestId;
}

function writeLastImgRequestId() {
    window.lastImgRequestId = getImgRequestId();
}

function isLastImgRequestIdChanged() {
    return getImgRequestId() !== window.lastImgRequestId;
}